import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2a9a035e&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9a035e')) {
      api.createRecord('2a9a035e', component.options)
    } else {
      api.reload('2a9a035e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2a9a035e&", function () {
      api.rerender('2a9a035e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/configs/edit.vue"
export default component.exports